import * as React from 'react';
import Box from '@mui/material/Box';
import { Radio, AudioLines, Library, Calendar, BadgeInfo } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

export const SIDENAV_WIDTH = 300;
const ROW_HEIGHT = 48;
const NAV_ITEMS = ['broadcast', 'feed', 'shows', 'schedule', 'about'];
const NAV_PADDING_TOP = 16;
export const SIDENAV_HEIGHT = NAV_PADDING_TOP + ROW_HEIGHT * NAV_ITEMS.length;

function getValueForLocation(location) {
  if (location.pathname === '/') {
    return 'broadcast';
  } else if (location.pathname.startsWith('/feed')) {
    return 'feed';
  } else if (location.pathname === '/shows') {
    return 'shows';
  } else if (location.pathname.startsWith('/show')) {
    return 'shows';
  } else if (location.pathname === '/schedule') {
    return 'schedule';
  } else if (location.pathname === '/about') {
    return 'about';
  } else {
    return 'recents';
  }
}

export default function SideNavigation({ onNavigate }) {
  const location = useLocation();
  const theme = useTheme();
  const value = getValueForLocation(location);

  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <Box sx={{ paddingTop: `${NAV_PADDING_TOP}px` }}>
      {NAV_ITEMS.map((val) => {
        const label =
          val === 'broadcast' ? 'Broadcast' :
          val === 'feed' ? 'Feed' :
          val === 'shows' ? 'Shows' :
          val === 'schedule' ? 'Schedule' :
          'Info';

        const icon =
          val === 'broadcast' ? <Radio size={22} /> :
          val === 'feed' ? <AudioLines size={22} /> :
          val === 'shows' ? <Library size={22} /> :
          val === 'schedule' ? <Calendar size={22} /> :
          <BadgeInfo size={22} />;

        const active = value === val;

        return (
          <Box
            key={val}
            component={Link}
            to={`/${val === 'broadcast' ? '' : val}`}
            onClick={handleClick}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              height: ROW_HEIGHT,
              paddingX: 2,
              textDecoration: 'none',
              borderLeft: active ? `3px solid ${theme.palette.primary.main}` : '3px solid transparent',
              color: active ? theme.palette.primary.main : '#868686',
              fontWeight: active ? 700 : 400,
            }}
          >
            <Box sx={{ display: 'flex' }}>{icon}</Box>
            <Box sx={{ fontSize: '0.95rem' }}>{label}</Box>
          </Box>
        );
      })}
    </Box>
  );
}
